import FrameSizes from "./FrameSizes";

// Snaps an arbitrary sample count to the closest valid entry in the FrameSizes LUT.
export const findNearestFrameSize = (samples) => {
  return FrameSizes.reduce((nearest, candidate) =>
    Math.abs(candidate - samples) < Math.abs(nearest - samples)
      ? candidate
      : nearest,
  );
};

// Pulls `steps` frame sizes evenly spaced between min and max (inclusive), each
// snapped to the nearest valid LUT value, with duplicates removed.
export const computeFrameSizeList = (min, max, steps) => {
  const lo = Math.min(min, max);
  const hi = Math.max(min, max);

  if (steps <= 1) return [findNearestFrameSize(lo)];

  const values = [];
  for (let i = 0; i < steps; i++) {
    const raw = lo + ((hi - lo) * i) / (steps - 1);
    values.push(findNearestFrameSize(raw));
  }

  return [...new Set(values)].sort((a, b) => a - b);
};

// Frame sizes are stored/sent in samples but shown to the user in ms.
export const formatFrameSizeMs = (samples, sampleRate) => {
  if (!sampleRate) return `${samples} samples`;
  return `${((samples / sampleRate) * 1000).toFixed(1)}ms`;
};
